$(function() {
  $('a.open-menu').click( function(e) {
    e.preventDefault();
    $('.menu-lateral').css('width', '300px');
  });
  $('a.close-menu').click( function(e) {
    e.preventDefault();
    $('.menu-lateral').css('width', '0px');
  });
  $('.menu-lateral #menu-principal > li > a').click( function(e) {
    e.preventDefault();
    $(this).siblings('.sub-menu').toggle();
  });
  $('.menu-lateral #menu-principal > li#menu-item-55 > .sub-menu > li > a').click( function(e) {
    e.preventDefault();
    $(this).siblings('.sub-menu').toggle();
  });
  $('.evenement #voir-large').click( function(e) {
    e.preventDefault();
    $('#modal-image').modal();
  });
  $('.toggle-filtres').click( function(e) {
    e.preventDefault();
    $('.categories').toggle();
    $('form.filtres').toggle();
  });
  // Cierre del menú
  $(document).click(function(e) {
    var target = $(e.target);
    if ( target.closest('.menu-lateral').length == 0 && $('.menu-lateral').css('width') != '0px' )
      $('.menu-lateral').css('width', '0');
  });
  $('.info-evenement img').on('error', function () {
    if ( $(this).data('type_activite') && $(this).data('type_activite') != 6 )
      $(this).attr('src', 'https://themaa.elpuntodoc.com/wp-content/uploads/2021/11/placeholder_' + $(this).data('type_activite') + '.jpg');
    else 
      $(this).attr('src', 'https://themaa.elpuntodoc.com/wp-content/uploads/2021/11/placeholder_1.jpg');
  });
  $('#voir-large img').on('error', function () {
    $(this).attr('src', 'https://themaa.elpuntodoc.com/wp-content/uploads/2021/11/placeholder_' + $(this).data('type_activite') + '.jpg');
  });
  // Espace membre - mot de passe oublié
  $('body.page-id-34684').on('click', '.mot-passe-oublie', function(e) {
    e.preventDefault();
    $('#espace-adherent').modal('hide');
    $('#mot-de-passe-oublie').modal();
  });
});



// WEBPACK FOOTER //
// ./scripts/custom.js